<template>
	<div id="metatop">
		<div class="top">
			<div class="b_banxin ">
				<div class="flex">
					<div class="topleft flex">
						<img src="../assets/img/gonggao.png" alt="" class="topleftimg">
						<div class="toplefttxt">
							<ul class="new-list" :class="{anim:animate}" @mouseenter="Stop()" @mouseleave="Up()">
								<li v-for="(item,index) in noticelist" :key="index" class="txtnowarp" @click="tonew(item)">
									{{item.title}}
								</li>
							</ul>
						</div>
					</div>
					<div class="topright flex flex_right">
						<div class="toprightsons" @click="goOld">
							前往旧网站
						</div>
						<div class="toprightson" v-if="username != ''">
							您好，<span style="color:#dc1e33">{{username}}【{{dengji}}】</span>，欢迎回来！
						</div>
						<div class="toprightson" v-else>
							您好，欢迎光临本店！<span style="color:#dc1e33" @click="goLogin">请登录</span><span @click="goRegister" style="color:#dc1e33;display: inline-block;margin-left: 10px;">免费注册</span>
						</div>
						<div class="toprightson" @click="exitFn" v-if="username != ''">
							退出
						</div>
						<div class="toprightson" @click="orderFn">
							我的订单
						</div>
						<div :class="{toprightson:true,_active:newalert}">
							<img src="../assets/img/email1.png" alt="" class="_ico1" v-if="newalert"  @click="tabnewalert">
							<img src="../assets/img/email2.png" alt="" class="_ico1" v-else  @click="tabnewalert">
							<div class="_ico1num" v-if="malikey">
								{{numberall}}
							</div>
							<div class="_news" v-show="newalert"  @mouseleave="leave()">
								<div class="_newslist1">
								站内信
								</div>
                <div class="_newslist2" @click="topersonalinformation(item)" v-for="(item,index) in mail" :key="index">
								 <div class="_newslist2son txtnowarp2">
                  [站内信]{{item.title}}
                 </div>
								</div>
								<div class="_newslist3" @click="tohome">
									查看全部
								</div>
							</div>
						</div>
						<div class="toprightson erweima">
							关注公众号
							<div class="erweima_hover">
								<div class="erweima_hover_top">
									扫描二维码
								</div>
								<div class="erweima_hover_top">
									关注51文具
								</div>
								<img src="../../public/img/erweima.png"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import qs from "qs";
import { constants } from "buffer";
export default {
  name: "metatop",
  metaInfo() {
    return {
      title:this.title_,
      meta:this.meta_,
    };
  },
  data() {
    return {
      noticelist: [],
      mail: [],
      malikey: false,
      animate: false,
      intNum: undefined,
      username: '',
      newalert: false,
      alertkey: false,
      numberall:0,
      dengji:'',//会员等级展示
      title_:'',
      meta_:[
        {
          name:'keywords',
          content:'',
        },{
          name:'description',
          content:'',
        },
      ],
    };
  },
  created() {
    let that = this;
    that.ScrollUp();
    that.getnewall();
    that.getnewalls();
    if (that.$storage.get("user_data") != null) {
      if (that.$storage.get("user_data").user_name == '' || that.$storage.get("user_data").user_name == null){
        that.username = that.$storage.get("user_data").alias;


      }else{
        that.username = that.$storage.get("user_data").user_name;
      }
      if (that.$storage.get("user_data").rank_id == 0 || that.$storage.get("user_data").rank_id == 1){
        that.dengji = '注册会员'
      }else if (that.$storage.get("user_data").rank_id == 2){
        that.dengji = '加盟商'
      }else if (that.$storage.get("user_data").rank_id == 3){
        that.dengji = 'A级会员'
      }else if (that.$storage.get("user_data").rank_id == 4){
        that.dengji = 'VIP会员'
      }else if (that.$storage.get("user_data").rank_id == 5){
        that.dengji = '专业会员'
      }else if (that.$storage.get("user_data").rank_id == 6){
        that.dengji = '直销商'
      }
      that.malikey = true; //控制站内信登录状态
      that.getmailnum();
    } else {
      that.username = '';
      that.mail = [];
      that.malikey = false; //控制站内信登录状态
    }
  },
  watch: {
    $route() {
      let that = this;
      // alert(that.$route.name)
      that.getmailnum()
    }
  },
  methods: {
    ScrollUp() {
      this.intNum = setInterval(() => {
        this.animate = true; // 向上滚动的时候需要添加css3过渡动画
        setTimeout(() => {
          this.noticelist.push(this.noticelist[0]); // 将数组的第一个元素添加到数组的
          this.noticelist.shift(); //删除数组的第一个元素
          this.animate = false;
        }, 500);
      }, 3000);
    },
    //鼠标移上去停止
    Stop() {
      let that = this;
      clearInterval(that.intNum);
    },
    goOld(){
    	let that = this;
    	window.open('http://old.51wenju.com.cn/')
    },
    Up() {
      let that = this;
      that.ScrollUp();
    },
    exitFn() {
      let that = this;
      that.$confirm("您将退出登录并跳转至首页, 是否继续?", "系统提示", {
        confirmButtonText: "确定退出",
        cancelButtonText: "我再想想",
        center: true,
        customClass: "alertboxq",
        confirmButtonClass: "alertboxqbtn1"
      })
        .then(() => {
          that.$message({
            type: "success",
            message: "您已成功退出登录!"
          });
          that.$storage.remove("user_data");
          that.username = "";
          that.$router.push({
            path: "/indexinner",
            query: {}
          });
          that.malikey = false;

        })
        .catch(() => {});
    },
    //注册方法跳转
    goRegister() {
      let that = this;
      that.$router.push({
        path: "/register",
        query: {}
      });
    },
    //登录方法跳转
    goLogin() {
      let that = this;
      that.$router.push({
        path: "/login",
        query: {}
      });
    },
    //站内信查看全部
    tohome() {
      let that = this;
      that.$router.push({
        path: "/personalinforlist",
        query: { id: "2"}
      });
    },
    //订单方法跳转
    orderFn() {
      let that = this;
      if (that.username == "") {
        that.$message({
          message: "请先登录或注册！",
          type: "warning"
        });
      } else {
        that.$router.push({
          path: "/personalOrder",
          query: {}
        });
      }
    },
    //站内信展示
    tabnewalert() {
      let that = this;
      if (that.username == "") {
        that.$message({
          message: "请先登录或注册！",
          type: "warning"
        });
      } else {
        this.newalert = !this.newalert;
      }

    },
    //站内信详情跳转
    topersonalinformation(index) {
      let that = this;
      that.$router.push({
        path: "/personalinformation",
        query: { id: "2", bookid: index.id }
      });
    },
    leave() {
      this.newalert = !this.newalert;
    },
    //公告详情跳转
    tonew(index) {
      let that = this;
      that.$router.push({
        path: "/personalinformation",
        query: { id: "1", bookid: index.id }
      });
    },
    getnewalls() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.searchlist,
        data: qs.stringify({})
      })
        .then(function(response) {
          let data = response.data;
          if (data.stateCode == 10000) {
            // that.icp = data.data.icp
            that.title_ = data.data.search;
            that.meta_ = [
              {
                name:'keywords',
                content:data.data.key,
              },{
                name:'description',
                itemprop:'description',
                content:data.data.dec,
              },
            ]
          } else {
            that.$message({
              message: data.msg,
              type: "warning"
            });
          }
        })
        .catch(function(error) {});
    },
    //获取公告列表
    getnewall() {
      let that = this;

      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.getnewall,
        data: qs.stringify({
          sign: "2",
          page: "1"
        })
      })
        .then(function(response) {
          //						console.log(response);
          let data = response.data;
          if (data.stateCode == 10000) {
            that.noticelist = data.data;

          } else {

            that.$message({
              message: data.msg,
              type: "warning"
            });
          }
        })
        .catch(function(error) {});
    },
    getmailnum() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.getmailnum,
        data: qs.stringify({
          user_id: that.$storage.get("user_data").user_id
        })
      })
        .then(function(response) {
          let data = response.data;
          if (data.stateCode == 10000) {


            that.numberall=data.count;
            let godata = data.data;
            if(data.data==null){
                that.malikey = false; //控制站内信登录状态
               that.mail=[]
            }
              if (godata.length >= 3) {
              that.mail = godata.slice(0, 3);
            } else {
              that.mail = data.data;
            }
          } else {
            that.$message({
              message: data.msg,
              type: "warning"
            });
          }
        })
        .catch(function(error) {});
    },
    //判断是否登录
    iflogin() {
      // console.log(that.$storage.get("user_data").user_id);
    }
  }
};
</script>
<style scoped>
.top {
  width: 100%;
  height: 50px;
  background-color: #eeeeee;
}

.topleft {
  width: 340px;
  height: 50px;
}

.topleft img {
  width: 30px;
  height: 50px;
  display: block;
  object-fit: scale-down;
  margin-left: 20px;
}
.alertboxq {
  min-height: 300px;
}
.toplefttxt {
  width: 310px;
  height: 50px;
  padding: 0 10px;
  overflow: hidden;
}

.new-list {
  line-height: 50px;
  transition: top 1s;
}

.new-list li {
  display: block;
  font-size: 16px;
  cursor: pointer;

}

.anim {
  transition: all 1s;
  margin-top: -50px;
  /* //高度等于行高 */
}

.topright {
  width: 960px;
  height: 50px;
}

.toprightson {
  height: 50px;
  line-height: 50px;
  padding: 0 10px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
}
.toprightsons {
  height: 50px;
  line-height: 50px;
  padding: 0 10px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  color: blue;
  text-decoration:underline;
}
.erweima {
  position: relative;
}
.erweima_hover {
  position: absolute;
  top: 50px;
  right: 0;
  text-align: center;
  width: 120px;
  background: white;
  color: #333333;
  z-index: 1000;
  /*height: 210px;*/
  box-shadow: 0 1px 6px #cccccc;
  box-sizing: border-box;
  padding: 5px;
  display: none;
}
.erweima_hover_top {
  color: #333333;
  font-size: 14px;
  width: 100%;
  text-align: center;
  height: 24px;
  line-height: 24px;
}
.erweima_hover img {
  display: inline-block;
  width: 100%;
}
.erweima:hover {
  color: #dc1e33;
}
.erweima:hover .erweima_hover {
  display: block;
}
._ico1 {
  width: 25px;
  height: 17px;
  display: block;
  margin: 0 auto;
  margin-top: 17px;
}
._ico1num {
  overflow: hidden;
  padding: 2px 5px;
  color: #ffffff;
  font-size: 10px;
  position: absolute;
  top: 10px;
  line-height: 14px;
  right: 0;
  background-color: #dc1e33;
  border-radius: 5px;
}
._active {
  background-color: #dc1e33;
}
._news {
  width: 220px;
  background-color: #ffffff;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 200;
  -webkit-box-shadow: 0 5px 6px #ccc;
  box-shadow: 0 5px 6px #ccc;
}
._newslist1 {
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  padding: 0 20px;
  font-size: 16px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
}
._newslist2 {
  width: 100%;
  padding: 15px 20px;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
._newslist2son {
  width: 100%;
  max-height: 40px;
  font-size: 12px;
  line-height: 20px;
}
._newslist2:hover {
  background-color: #db1e34;
  color: #ffffff;
}
._newslist3 {
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  padding: 0 20px;
  font-size: 12px;
  text-align: center;
  width: 100%;
  cursor: pointer;
}
</style>
